import React, { useRef, useState  } from "react";
import { useDispatch } from "react-redux";
import { setNotification } from "../../redux/notificationSlice";
import { helpDocAPI } from "../../api";

export const UploadDoc = () => {
    const externalRef = useRef(null);
    const internalRef = useRef(null);
    const [externalDoc, setExternalDoc] = useState(null);
    const [internalDoc, setInternalDoc] = useState(null);

    const dispatch = useDispatch();

     const handleExternalChange = async(e) => {
        const file = e.target.files[0];
        if (file && file.type === "application/pdf") {
            setExternalDoc(file);
        } else {
            setExternalDoc(null);
            dispatch(
                setNotification({
                    type: "warning",
                    show: true,
                    message: "Please select a pdf file.",
                })
            );
        }
    };

    const handleInternalChange = (e) => {
        const file = e.target.files[0];
        if (file && file.type === "application/pdf") {
            setInternalDoc(file);
        } else {
            setInternalDoc(null);
            dispatch(
                setNotification({
                    type: "warning",
                    show: true,
                    message: "Please select a pdf file.",
                })
            );
        }
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        const externalFile = externalRef.current?.files[0];
        const internalFile = internalRef.current?.files[0];
        const bucket_name = process.env.REACT_APP_UG_BUCKET_NAME;
        let internalUploadResp, externalUploadResp
        if (!externalFile && !internalFile) {
            dispatch(
                setNotification({
                type: "warning",
                show: true,
                message: "Please select files to upload.",
                })
            );
            return;
        }
        if(internalFile){
            setInternalDoc(null)
            const buffer = await internalFile.arrayBuffer();
            const requestData = {
                operation: "uploadHelpGuide",
                request: { 
                    type: "internal",
                    bucket: bucket_name, 
                    filename: "Help Document for GCTO Service Provider Portal - Merck User.pdf",
                    contentType: internalFile.type,
                    file: Array.from(new Uint8Array(buffer)) 
                }
            }
            internalUploadResp = await helpDocAPI(requestData)
        }
        if(externalFile){
            setExternalDoc(null)
            const buffer = await externalFile.arrayBuffer();
            const requestData = {
                operation: "uploadHelpGuide",
                request: { 
                    type: "external", 
                    bucket: bucket_name,
                    filename: "Help Document for GCTO Service Provider Portal - Non Merck User.pdf",
                    contentType: externalFile.type,
                    file: Array.from(new Uint8Array(buffer)) 
                }
            }
            externalUploadResp = await helpDocAPI(requestData)
        }
        if (externalRef.current) {
          externalRef.current.value = null;
        }
        if (internalRef.current) {
          internalRef.current.value = null;
        }
        const internalSuccess = internalFile && internalUploadResp.responseCode === 200;
        const externalSuccess = externalFile && externalUploadResp.responseCode === 200;
        const internalFail = internalFile && internalUploadResp.responseCode !== 200;
        const externalFail = externalFile && externalUploadResp.responseCode !== 200;
        if (internalFail || externalFail) {
            dispatch(
                setNotification({
                    type: "error",
                    show: true,
                    message: "There was an error uploading the Internal or External help guide.",
                })
            );
        } else if (internalSuccess || externalSuccess) {
            dispatch(
                setNotification({
                    type: "success",
                    show: true,
                    message: "Help Guide uploaded successfully",
                })
            );
        }  
    };

    return (
        <form
            className="min-w-full mx-auto p-6 bg-white rounded shadow space-y-6"
            onSubmit={handleSubmit}
        >
            <div className="grid grid-cols-2 gap-4 items-center">
                <label htmlFor="external-guide" className="block text-sm font-medium text-gray-700 mb-2">
                    Upload External Help Guide (.pdf)
                </label>
                <div>
                    <input
                        type="file"
                        id="external-guide"
                        accept=".pdf,application/pdf"
                        ref={externalRef}
                        onChange={handleExternalChange}
                        className="block w-full text-sm text-gray-700 file:mr-4 file:py-2 file:px-4 file:rounded file:border-0 file:text-sm file:font-semibold file:bg-teal-50 file:text-teal-700 hover:file:bg-teal-100"
                        style={{ color: "transparent" }}
                    />
                    {externalDoc && (
                        <div className="flex items-center mt-1 space-x-2">
                            <p className="text-teal-700 text-xs">
                                Selected: {externalDoc.name}
                            </p>
                        </div>
                    )}
                </div>
            </div>
            <div className="grid grid-cols-2 gap-4 items-center">
                <label htmlFor="internal-guide" className="block text-sm font-medium text-gray-700 mb-2">
                    Upload Internal Help Guide (.pdf)
                </label>
                <div>
                    <input
                        type="file"
                        id="internal-guide"
                        accept=".pdf,application/pdf"
                        ref={internalRef}
                        onChange={handleInternalChange}
                        className="block w-full text-sm text-gray-700 file:mr-4 file:py-2 file:px-4 file:rounded file:border-0 file:text-sm file:font-semibold file:bg-teal-50 file:text-teal-700 hover:file:bg-teal-100"
                        style={{ color: "transparent" }}
                    />
                    {internalDoc && (
                        <div className="flex items-center mt-1 space-x-2">
                            <p className="text-teal-700 text-xs">
                                Selected: {internalDoc.name}
                            </p>
                        </div>
                    )}
                </div>
            </div>
            <button
                type="submit"
                className="px-4 py-2 bg-sky-800 text-white hover:bg-sky-900"
            >
                Submit
            </button>
        </form>
    );
};
